module.exports = __webpack_public_path__ + "static/media/strawberryVid.6042e1a6.mp4";